import { useLocation } from 'react-router-dom';
import { getRouteMetadata } from './registerRoutes';

export function useCurrentRouteMetadata() {
    const location = useLocation();
    return getRouteMetadata(location.pathname);
}
